import { render, staticRenderFns } from "./DeleteDocumentModal.vue?vue&type=template&id=1496e892&"
import script from "./DeleteDocumentModal.vue?vue&type=script&lang=js&"
export * from "./DeleteDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1496e892')) {
      api.createRecord('1496e892', component.options)
    } else {
      api.reload('1496e892', component.options)
    }
    module.hot.accept("./DeleteDocumentModal.vue?vue&type=template&id=1496e892&", function () {
      api.rerender('1496e892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/DeleteDocumentModal.vue"
export default component.exports